module.exports = __webpack_public_path__ + "img/SE5164060872.d1d1a6a6.png";